import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { ActiveSubscriptionRedeeemGiftCardUseCase } from './ActiveSubscriptionRedeeemGiftCardUseCase';
import { GiftCardUserResubscribeUseCase } from './GiftCardUserResubscribeUseCase';
import { GiftCardUserResubscribeVerifyUseCase } from './GiftCardUserResubscribeVerifyUseCase';
import { ReSubscribeViaGiftCardUseCase } from './ReSubscribeViaGiftCardUseCase';
import { SubscribeViaGiftCardUseCase } from './SubscribeViaGiftCardUseCase';
import { ValidateGiftCardUseCase } from './ValidateGiftCardUseCase';

export const initializeDiscountUseCases = (container: Container) => {
    container.register(DI.USECASES.IActiveSubscriptionRedeeemGiftCardUseCase, {
        useClass: ActiveSubscriptionRedeeemGiftCardUseCase,
    });
    container.register(DI.USECASES.IGiftCardUserResubscribeUseCase, {
        useClass: GiftCardUserResubscribeUseCase,
    });
    container.register(DI.USECASES.IGiftCardUserResubscribeVerifyUseCase, {
        useClass: GiftCardUserResubscribeVerifyUseCase,
    });
    container.register(DI.USECASES.IReSubscribeViaGiftCardUseCase, {
        useClass: ReSubscribeViaGiftCardUseCase,
    });
    container.register(DI.USECASES.ISubscribeViaGiftCardUseCase, {
        useClass: SubscribeViaGiftCardUseCase,
    });
    container.register(DI.USECASES.IValidateGiftCardUseCase, {
        useClass: ValidateGiftCardUseCase,
    });
};
